export default __webpack_public_path__ + "icon-pad.svg";